import { createRoot } from 'react-dom/client';

import App from './App.js';
import { applyStoredA11yPrefs } from './ui/a11yPrefs.js';
import { installBrowserLayoutController } from './ui/layout/layoutController.js';
import { installAudio } from './game/audio/index.js';
import { logBuildBanner } from './version.js';
import { installClientDiagnostics } from './net/bugReport.js';
import './styles.css';
import './ui/theme.css';
import './ui/layout/mobile-layout.css';
import './ui/touch/touch-controls.css';
import './ui/ability-slot.css';

// E1.6.S1 — the client build/version stamp boot line (build sha + mode), readable
// in the console without dev tools. Also surfaced in Settings → About (SystemPanels).
logBuildBanner(import.meta.env.MODE);

// q-bug-report-button: keep a short tail of the client's own console errors/warnings and
// uncaught errors, attached to an in-game bug report (never chat or other players' words).
installClientDiagnostics();

// The player's saved accessibility prefs apply before the first paint, not only once
// the Accessibility panel is opened (q-p2triage-fe-player-trust-and-ux).
applyStoredA11yPrefs();

// Portrait / short-landscape HUD (q-portrait-hud-and-orientation-settings, AD-817): set
// <html data-layout> before the first render and keep it in step with rotation + settings.
installBrowserLayoutController();
installAudio(); // AD-861: silent until the first tap (autoplay rules); Settings → Sound

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('missing #root element');

// O-003: mount WITHOUT React.StrictMode. StrictMode's dev-only mount→unmount→remount
// double-invokes GameScreen's effect, which imperatively creates a Three.js
// WebGLRenderer (Game.ts). So the dev build the TECHDEMO capture films built TWO
// WebGL contexts, and the world root rendered into the discarded one — blanking every
// captured clip while lit entities still drew (2026-W28 vanishing-world investigation).
// The game view owns an imperative GL canvas whose lifecycle is single-mount by design;
// production never double-mounts (StrictMode is a dev-only no-op there). Game.dispose()
// is also hardened to fully release its context + dev hook, so any future remount
// (route change / HMR) can never leave a live orphan context behind.
createRoot(rootEl).render(<App />);
